/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';

/**
 * PageHeader provides a native iOS-like large header title, which automatically
 * attaches the title of the page to the navigation bar on scroll.
 *
 * showLargeTitle: Bool - mimics iOS style large titles.
 */
export default class PageHeader extends Component {
  // icon specifies a paper icon to display in the header.
  icon = '';

  // nestedRoute flags that we're on a nested route, with reduced top nav.
  @tracked nestedRoute = false;

  // title specifies the title to display in the header.
  title = '';

  // stickyClasses determines the CSS class(es) for the "sticky" element.
  get stickyClasses() {
    let classes = ['page-header-sticky'];

    if (this.nestedRoute) {
      classes.push('page-header-sticky--on-nested-route');
    }

    return classes.join(' ');
  }
}
